import { useTheme } from "@emotion/react";
import useStyles from "./styles";
import { Paper, Typography, LinearProgress, Box } from "@mui/material";
import InfoPopover from "../../infoPopover";
import {
	BarChartOutlined,
	GroupAddOutlined,
	HandymanOutlined,
	LoginOutlined,
	QueryStatsOutlined,
	SpeedOutlined,
	TimelineOutlined,
	WarningOutlined,
	DownloadOutlined,
	PublishOutlined,
	MemoryOutlined,
	RouterOutlined,
	SettingsInputComposite,
	CheckOutlined,
	AccessTimeOutlined,
	ErrorOutlineOutlined,
	AddCircleOutlineOutlined,
} from "@mui/icons-material";

const iconComponents = {
	1: SpeedOutlined,
	2: TimelineOutlined,
	3: BarChartOutlined,
	4: QueryStatsOutlined,
	5: GroupAddOutlined,
	6: HandymanOutlined,
	7: WarningOutlined,
	8: LoginOutlined,
	9: DownloadOutlined,
	10: PublishOutlined,
	11: MemoryOutlined,
	12: RouterOutlined,
	13: SettingsInputComposite,
	14: CheckOutlined,
	15: AccessTimeOutlined,
	16: ErrorOutlineOutlined,
	17: AddCircleOutlineOutlined,
};

export default function CardDataComponent(params) {
	const {
		cardTile,
		cardValue,
		typeIcon = 3,
		icon = null,
		colorCard = "inputData",
		loading = false,
		paramsColor = null,
		info = null,
	} = params;

	const theme = useTheme();
	const styles = useStyles(theme);
	const IconComponent = icon || iconComponents[typeIcon];

	return (
		<Paper
			variant={theme.palette.mode === "dark" ? "outlined" : "elevation"}
			elevation={theme.palette.mode == "dark" ? 0 : 3}
			sx={{
				...styles.containerPaper,
				backgroundColor:
					paramsColor?.card ||
					theme.palette.cardTrafficData.paperColor[colorCard],
			}}
		>
			{loading && <LinearProgress sx={styles.linearProgress} />}

			<IconComponent
				sx={{
					...styles.speedIcon,
					color:
						paramsColor?.icon ||
						theme.palette.cardTrafficData.iconColor[colorCard],
				}}
			/>

			<Box
				sx={{
					width: "100%",
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					gap: 0.5,
					zIndex: 1,
				}}
			>
				<Typography sx={styles.titleCard}>{cardTile}</Typography>
				{info && (
					<InfoPopover
						{...info}
						sxIcon={{ color: theme.palette.white.main, p: 0.25 }}
					/>
				)}
			</Box>

			<Box sx={styles.containerBodyCard}>
				<Box
					sx={{
						...styles.containerIconCard,
						backgroundColor:
							paramsColor?.container ||
							theme.palette.cardTrafficData.containerColorIcon[colorCard],
					}}
				>
					<IconComponent
						sx={{
							color:
								paramsColor?.icon ||
								theme.palette.cardTrafficData.iconColor[colorCard],
							fontSize: "20px",
						}}
					/>
				</Box>

				<Typography
					color={
						paramsColor?.icon ||
						theme.palette.cardTrafficData.iconColor[colorCard]
					}
					sx={{ fontSize: "20px", fontWeight: "bold" }}
				>
					{cardValue}
				</Typography>
			</Box>

			{params.helperText && (
				<Box sx={{ width: "100%", display: "flex", justifyContent: "left", mt: 1 }}>
					<Typography sx={{ ...styles.titleCard, fontSize: "13px", opacity: 0.8, fontWeight: 600 }}>
						{params.helperText}
					</Typography>
				</Box>
			)}
		</Paper>
	);
}
